import Vue from 'vue'

const requireComponent = require.context('./global', true, /index\.js/)

requireComponent.keys().forEach(filename => {
  const component = requireComponent(filename)
  const ctor = component.default || component
  Vue.component(ctor.name, ctor)
})
